import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import { useStyles } from './buttons.style';
import { CommonButtonTypes } from 'Common/Types/Types';
import CustomNavigationIcon from '../../Icons/CustomNavigationIcon';
import { useHistory } from 'react-router-dom';

// this button handles the next option
export const NextButton = ({ common, onClick }: CommonButtonTypes) => {
	return (
		<Fragment>
			<div style={{ margin: common?.margin ? common.margin : '0' }} onClick={onClick}>
				<CustomNavigationIcon
					width={common?.width}
					height={common?.height}
					arrowSvgColor={common?.arrowSvgColor}
					roundSvgBackground={common?.roundSvgBackground}
				/>
			</div>
		</Fragment>
	);
};
interface BackButtonProps extends CommonButtonTypes {
	image: any | undefined;
	transparent?: any | undefined;
}
export const BackButton = ({ common, image, transparent }: BackButtonProps) => {
	const classes = useStyles({ common });
	const history = useHistory();
	return (
		<Fragment>
			<div style={{ margin: common?.margin ? common.margin : '0' }} onClick={() => history.goBack()}>
				<img
					src={image}
					alt=""
					className={classes.goBack}
					style={{
						background: transparent ? 'grey' : '',
						padding: transparent ? '.5rem .6rem' : '',
						borderRadius: transparent ? '200px' : '',
						margin: transparent ? '.5rem 1rem' : '',
					}}
				/>
			</div>
		</Fragment>
	);
};

// this button handles yes or no functionalities of the application,
// provide at-least one condition and a functional command
export const ConditionalButton = ({ condition, onClick }: CommonButtonTypes) => {
	const classes = useStyles({ condition });
	// eslint-disable-next-line no-console
	console.log(condition)
	return (
		<Fragment>
			<Button size="medium" className={classes.conditional} onClick={onClick}>
				<span className="text-capitalize px-2">{condition}</span>
			</Button>
		</Fragment>
	);
};

// this a button that holds the icons, it's not clickable at the moment
export const IconHolder = ({ common }: CommonButtonTypes) => {
	const classes = useStyles({ common });

	return (
		<Fragment>
			<div className={classes.iconHolder}>
				<img src={common?.icon} alt="" />
			</div>
		</Fragment>
	);
};

export const CommonButton = ({ common, command, onClick, disabled ,addLineHeight}: CommonButtonTypes) => {
	const classes = useStyles({ common,addLineHeight });
	return (
		<Fragment>
			<Button
				color="primary"
				variant="contained"
				fullWidth
				type="submit"
				disabled={disabled}
				onClick={onClick}
				className={`${classes.commonButton}  mt-4`}
			>
				{command}
			</Button>
		</Fragment>
	);
};
